// src/hooks/useFilterOptions.js
import { useMemo } from "react";
import { optionsFromList, optionsFromMap } from "../utils/selectOptions";

/**
 * Мемоизированные опции для Select из массива сущностей.
 *
 * Ключевое отличие от голого `useMemo(() => optionsFromList(...), [list])`:
 * маппер должен быть СТАБИЛЬНОЙ ссылкой (модульная функция), а не
 * inline-стрелкой. Inline-стрелка меняет идентичность каждый рендер,
 * из-за чего useMemo пересчитывает массив зря. Правило зафиксировано
 * самим API хука: используй мапперы из utils/selectOptions.js
 * (toProjectOption, toEmployeeOption, ...) - они стабильны.
 */
export function useFilterOptions(list, allLabel, mapper) {
  return useMemo(
    () => optionsFromList(list, allLabel, mapper),
    [list, allLabel, mapper],
  );
}

/** То же для статических карт (PRIORITIES, STATUSES, ...). */
export function useMapOptions(map, allLabel, labelOf) {
  return useMemo(
    () => optionsFromMap(map, allLabel, labelOf),
    [map, allLabel, labelOf],
  );
}
